export default "__VITE_ASSET__Bb1UJRnD__"